import { cn } from "@/lib/utils";

// Small accent-colored chip flagging pre-release surfaces. Pairs with the
// nav logo to signal the dashboard isn't GA yet.
interface BetaTagProps {
  label?: string;
  className?: string;
}

export function BetaTag({
  label = "Beta",
  className,
}: BetaTagProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center font-mono text-tiny font-semibold uppercase tracking-[0.14em]",
        "text-accent bg-accent/12 border border-accent/30 px-1.5 py-0.5 rounded-[var(--radius-1)]",
        className,
      )}
    >
      {label}
    </span>
  );
}
